import { render, staticRenderFns } from "./dragFormHorizontalLayout.vue?vue&type=template&id=4cfccc6f&"
import script from "./dragFormHorizontalLayout.vue?vue&type=script&lang=js&"
export * from "./dragFormHorizontalLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports